__turbopack_context__.v({
  "blogNav": "BlogArticle-module__wF98va__blogNav",
});
